import { formatDate } from "@angular/common";
import { LogService } from "../../../shared/services/log.service";
import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";

export class CTRL_1020 implements Validator {

    public static id = 'CTRL_1020';
    private message = 'error.ctr_1020';


    public LOG: LogService = new LogService(CTRL_1020);

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_1020.id + '_');


        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                const firstChamp = ctrl.value.rgCtrls.firstChamp;
                
                const firstChampNameWithStepId = map.get(firstChamp);
                
                const firstChampCtrl = form.controls[firstChampNameWithStepId];

                const toDay = new Date();
                if (firstChampCtrl.value !== 'yyyy-MM-dd' && firstChampCtrl.value !=="" && firstChampCtrl.value >= formatDate(toDay.setDate(toDay.getDate() + 3650), 'yyyy-MM-dd', 'en')) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }
}